<template>
    <div>
        <div class="skinny row">
            <div class="col-md-12">
                <vx-timeline :data="timelineNotes" />
            </div>
        </div>
        <div class="skinny row">
            <div class="col-md-10 mt-5">
                <vs-input icon-pack="feather" icon="icon-user" class="w-full" placeholder="Escribe un comentario..."
                    v-model="note" />
            </div>
            <div class="col-md-2 mt-5">
                <div class="flex flex-wrap">
                    <vs-button radius color="success" icon-pack="feather" icon="icon-send"
                        @click="sendNote()"></vs-button>
                    <vs-button v-if="total_notes > 3" class="ml-5" color="dark" size="small"
                        v-on:click="showNotes('all')">Ver todas</vs-button>
                </div>
            </div>
        </div>

        <vs-popup class="extended-popup header-primary" title="Notas" :active.sync="popupNotesActive">
            <vx-card>
                <div class="vx-row">
                    <div class="vx-col w-full lg:w-full">
                        <vx-timeline :data="timelineNotesPopup" />
                    </div>
                </div>
            </vx-card>
        </vs-popup>

    </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper";
import formatHelper from "@mixins/formatHelper";

export default {
    name: "InternalNotes",
    props: {
        projectId: {
            required: true
        },
        clientId: {
            required: true
        },
        displayPopup: {
            type: Boolean,
            default: false
        }
    },
    mixins: [formatHelper, dateHelper],
    async mounted() {
        await this.showNotes('top');
    },
    data() {
        return {
            note: '',
            timelineNotes: [],
            total_notes: 0,
            popupNotesActive:false,
            timelineNotesPopup: [],
        }
    },
    methods: {
        async sendNote() {
            if (this.note != '') {
                this.showLoading(true);
                await axios.post('/api/cobranza/notas', {
                    project: this.projectId,
                    note: this.note
                }).then(response => {
                    this.note = ''
                    this.notes = response.data.notes
                    this.timelineNotes = [];
                    this.total_notes = response.data.total_notes;
                    let number = this.total_notes - 2;
                    if (number <= 0) {
                        number = 1;
                    }
                    Object.keys(this.notes).forEach(key => {
                        const note = this.notes[key];
                        this.timelineNotes.push({
                            color: 'success',
                            icon: 'BellIcon',
                            desc: this.explicitDateFormat(note.created_at),
                            title: number + "-" + note.note,
                            time: "Registró: " + note.creator_name
                        });
                        number += 1;
                    })
                    this.showLoading(false);
                }).catch(error => {
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                    this.showLoading(false);
                })
            }
        },
        async showNotes(option) {
            this.showLoading(true);
            this.total_notes = 0;
            await axios.post('/api/cobranza/notas-listado', {
                project_id: this.projectId,
                client_id: this.clientId,
                option: option
            }).then(response => {
                let number = 1;
                this.total_notes = response.data.total_notes;
                if (option == 'top') {
                    number = this.total_notes - 2;
                }
                let timeline = []; 
                response.data.notes.forEach(element => {
                    const note = element;
                    timeline.push({
                        color: 'success',
                        icon: 'BellIcon',
                        desc: this.explicitDateFormat(note.created_at),
                        title: number + "-" + note.note,
                        time: "Registró: " + note.creator_name
                    });
                    number += 1;
                });
                if (option == 'all' && this.displayPopup) {
                    this.timelineNotesPopup = [];
                    this.timelineNotesPopup = timeline;
                    this.popupNotesActive = true;
                } else {
                    this.timelineNotes = [];
                    this.timelineNotes = timeline;
                }
                this.showLoading(false);
            }).catch(error => {
                this.showLoading(false);
                this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
            })
        }
    },

}
</script>